module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAMAAABg3Am1AAAAKlBMVEVMaXH////////////////////////////////////////////////////m1kuZAAAADXRSTlMAB2a4aTNa7reBpRIGVd/mLAAAAIBJREFUeNrt0zkSgCAUBFEEF3C5/3UNpJxiArssDZn09yMj+Oaj2ej3Djro4DPYpnulBUWXLWh7PnB5CCawbzZk7kFALwE9CPUgoJfgnkVSj0I9C+4lvGfhPQvrWSTvWTz0y7XowvtYw6Cv2Ap/f6yhgAn1ALSfwRphqwFeBy92AvaTNNt8i8keAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/mobile/ic_download.png
// module id = XoIz
// module chunks = 2